<template>
    <!-- BEGIN: Content-->
    <div class="mt-0">
      <div class="flex">
        <div class="section_title"><span class="big-size weight-bold">{{ $store.state.loader_text }}&nbsp;&nbsp;</span>
          <div class="load"><v-progress-circular
            color="primary"
            indeterminate
            :size="18"
            :width="3"
            v-show="loader"
          ></v-progress-circular></div>
        </div>

        <div style="display:flex;align-items:center;justify-content:space-between;flex-direction:row">
          <v-text-field
                v-model="searchfilter"
                label="Search"
                solo
                hide-details="auto"
                class="search_"
              ></v-text-field>
          <v-btn
            color="#000000"
            class="ma-1 white--text"
            depressed
            @click.stop="dialog = true"
          >
            Role
            <v-icon
              right
              dark
            >
              mdi-plus
            </v-icon>
          </v-btn>
        </div>
      </div>
      <div class="roleList">
        <v-container fluid style="padding-top:0 !important;padding-bottom:0 !important">

          <v-row style="margin-top:0 !important;margin-bottom:0 !important">
            <v-col md="12" sm="12" class="my-1 py-0 px-0">
              <v-card class="card-shadow py-0">
                <v-card-text class="px-0 py-3 cardtext">
                  <div class="empty-state" v-if="roles.length === 0 && !loader">
                      <div class="empty-state__content">
                        <div class="empty-state__icon">
                          <v-img src="@/assets/icon.png" alt=""></v-img>
                        </div>
                        <div class="empty-state__message">No records available.</div>
                      </div>
                    </div>
                  <v-virtual-scroll
                      :items="roles"
                      :item-height="20"
                      renderless 
                      id="virtualscroll"
                      class="roles"
                     >
                      <template v-slot:default="{ index,item }">
                          <div class="tcell">{{ index + 1 }}</div>
                          <div class="tcell">{{ item.name }}</div>
                          <div class="tcell">
                            <v-menu offset-x left bottom origin="center center" transition="scale-transition">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    icon
                                    v-bind="attrs"
                                    small
                                    v-on="on">
                                  <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
                                </v-btn>
                              </template>
                              
                              <v-list-item-group
                                color="primary"
                                class="actions"
                                >
                                  <v-list-item
                                    @click="editType(item.id)"
                                  >
                                      <v-list-item-icon>
                                        <v-icon color="#000000">mdi-pencil</v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-content>
                                        <v-list-item-title>Edit</v-list-item-title>
                                      </v-list-item-content>
                                  </v-list-item>

                                <v-list-item
                                  link
                                  @click="deleteItem(item.id)"
                                  >
                                      <v-list-item-icon>
                                        <v-icon>mdi-delete</v-icon>
                                      </v-list-item-icon>
                                      <v-list-item-content>
                                        <v-list-item-title>Remove</v-list-item-title>
                                      </v-list-item-content>
                                </v-list-item>

                              </v-list-item-group>
                            </v-menu>
                          </div>
                      </template>
                    </v-virtual-scroll>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <!-- add user dialog -->
        <v-dialog
          v-model="dialog"
          max-width="600px"
          >
          <v-card>

            <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

            <v-card-title>
              <span class="text-h6">Add Role</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        label="Role*"
                        v-model="item.role"
                        required
                        :rules="fieldRules"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-label class="mb-2">Permissions</v-label>
                      <v-row>
                        <v-col col="12" sm="6" md="4" lg="4" class="perm py-0 my-0" v-for="(permission, index) in permissions" :key="index">
                          <v-checkbox
                          v-model="item.permission" 
                          :id="permission.text" 
                          :value="permission.value"
                          :label="permission.text"
                          hide-details
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  :loading="loading"
                  :disabled="!valid"
                  @click="create"
                >
                  Save
                </v-btn>
            </v-card-actions>

          </v-form>
          </v-card>
        </v-dialog>
        <!-- end user -->
        <!-- user update modal-->
        <v-dialog
          v-model="updatedialog"
          max-width="600px"
          >
          <v-card>

            <v-form  enctype="multipart/form-data" v-model="valid" ref="form">

            <v-card-title>
              <span class="text-h6">Update Role</span>
            </v-card-title>

            <v-card-text>
                <v-container>
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-text-field
                        label="Role*"
                        v-model="item.updaterole"
                        required
                        :rules="fieldRules"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <v-label class="mb-2">Permissions*</v-label>
                      <v-row>
                        <v-col col="12" sm="6" md="4" lg="4" class="perm py-0 my-0" v-for="(permission, index) in permissions" :key="index">
                          <v-checkbox
                          v-model="item.updatepermission" 
                          :id="permission.text" 
                          :value="permission.value"
                          :label="permission.text"
                          hide-details
                          ></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="updatedialog = false"
                >
                  Close
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  :loading="loading"
                  :disabled="!valid"
                  @click="update"
                >
                  Save
                </v-btn>
            </v-card-actions>

          </v-form>
          </v-card>
        </v-dialog>
        <!-- update user -->
      </div>
    </div>

</template>
<style>
  .roleList .v-virtual-scroll__item{
    width:100%;
    display: grid !important;

     grid-auto-columns: minmax(33.333%, 33.333%) !important;
     /*grid-template-columns: 18.36% 12.28% 21.28% 20.56% 13.24% 14.28%;*/
     grid-auto-flow: column !important;
     grid-gap: 0px;
  }
</style>
<script>
import axios from 'axios'
import {ability} from '@/services/ability'
import $ from 'jquery';

export default {
    name:"roleList",
    data(){
        return {
          fieldRules: [
          (v) => !!v || 'Field is required'
          ],
          searchfilter:'',
          search:null,
          valid: true,
          searchrole:null,
          dialog: false,
          updatedialog: false,
          fields: [
             {
              text: '#',
              align: 'start',
              value: '#',
            },
            { text: 'Name', value: 'name' },
            { text: 'Action', value: 'action' },
           ],
          item:{
                role:"",
                permission: [],
                updatepermission: [],
                updaterole: "",
                updateID: "",
                _method:"patch"
            },
            loading: false,
           disabled: false,
           roles: [],
           height: '100%',
           permissions: [],
           isBusy: false,
            updateModal: null
        }
    },
    beforeMount() {
      // if(!ability.can('user-management', 'all')) {
      //   this.$router.push({ name: 'Dashboard' })
      //   return
      // }
    },
    mounted(){

      this.$store.state.loader_text = "User Roles"

      this.getRole()

      let headertitle = `<div class="v-virtual-scroll__container"><div class="v-virtual-scroll__item" style="top: 0px;">`;
      this.fields.map(function(value, key) {
           headertitle +=`<div class="thead">${value.text}</div>`;
         });
      headertitle +=`</div></div>`;
      $('.v-virtual-scroll').prepend(headertitle)

    },
    computed: {
      loader() {
        return this.$store.state.tableloader
      },
    },
    methods:{
      async getRole(){
        this.$store.state.tableloader = true
        await axios.get('/roles').then(response=>{
            this.$store.state.tableloader = false
            this.roles = response.data.roles
            this.permissions = response.data.permissions
        }).catch(error=>{
            console.log(error)
            this.$store.state.tableloader = false
            this.roles = []
        })
      },
       async create(){

        if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

          const config = { headers: { 'Content-Type': 'multipart/form-data' } };
          let fd = new FormData();
          fd.append('role',this.item.role)
          fd.append('permission',JSON.stringify(this.item.permission))

          await axios.post('/roles', fd, config).then(response=>{
            this.loading = false
            this.disabled = false
            this.res = response.status
            if(this.res === parseInt(200))
              this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
              this.getRole()
              this.clear()
            this.item.role = ''
            this.item.permission = ''
          }).catch(error=>{
            this.loading = false
            this.disabled = false
              console.log(error)
          })

        }

        },
        clear () {
          this.$refs.form.reset()
        },
        async update(){

          if (this.$refs.form.validate()) {

          this.loading = true
          this.disabled = true

            const config = { headers: { 'Content-Type': 'multipart/form-data' } };
            let fd = new FormData();
            fd.append('role',this.item.updaterole)
            fd.append('permission',JSON.stringify(this.item.updatepermission))
            fd.append('_method',this.item._method)

            await axios.post(`/roles/${this.item.updateID}`, fd, config).then(response=>{
              this.loading = false
              this.disabled = false
              this.res = response.status
              if(this.res === parseInt(200))
                this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
                this.updatedialog = false
                this.getRole()
              this.item.updaterole = ''
              this.item.updatepermission = ''
              this.item.updateID = ''
            }).catch(error=>{
              this.loading = false
              this.disabled = false
                console.log(error)
            })

          }

        },
      async editType(id) {
        let index = this.roles.filter(item => item.id === id );

        await axios.get(`/roles/${index[0].id}`).then(response=>{

          this.item.updatepermission = response.data.rolePermissions

          this.item.updaterole = index[0].name
          this.item.updateID = index[0].id
          this.updatedialog = true
          
        }).catch(error=>{
          this.loading = false
          this.disabled = false
            console.log(error)
        })

      },
      deleteItem(id){
            if(confirm("Are you sure to delete role ?")){
                axios.delete(`/roles/${id}`).then(response=>{
                  this.$toast.success(response.data.message,'Success',{position: 'topRight',timeout: 7000,})
                    this.getRole()
                }).catch(error=>{
                    console.log(error)
                })
            }
        }

    }
}
</script>